import { render, staticRenderFns } from "./talents_list.vue?vue&type=template&id=656a55e2&scoped=true"
import script from "./talents_list.vue?vue&type=script&lang=js"
export * from "./talents_list.vue?vue&type=script&lang=js"
import style0 from "./talents_list.vue?vue&type=style&index=0&id=656a55e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a55e2",
  null
  
)

export default component.exports